export const TOGGLE_SIDE_NAV = 'TOGGLE_SIDE_NAV';
export const SELECT_BOTTOM_NAV_ITEM = 'SELECT_BOTTOM_NAV_ITEM';
